module.exports = {
  USER_LEVEL: 1,
  MODERATOR_LEVEL: 2,
  ADMIN_LEVEL: 3,
};
